import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
var ApiVersion;
(function (ApiVersion) {
    ApiVersion["v1"] = "v1";
    ApiVersion["v2"] = "v2";
    ApiVersion["v3"] = "v3";
})(ApiVersion || (ApiVersion = {}));
var SmbCenterSubRoutes;
(function (SmbCenterSubRoutes) {
    SmbCenterSubRoutes["banking"] = "banking";
    SmbCenterSubRoutes["company"] = "samba-company";
    SmbCenterSubRoutes["accounting"] = "accounting";
    SmbCenterSubRoutes["security"] = "security";
    SmbCenterSubRoutes["products"] = "products";
})(SmbCenterSubRoutes || (SmbCenterSubRoutes = {}));
class UrlBase {
    /**
     * Get base url for smbCenter services calls for specific api version and route
     * @param version - v1, v2, or v3
     * @param subRoute - banking, samba-company, accounting or security
     * @returns string - base url for smbCenter services call
     */
    static getSmbCenterBaseUrl(version, subRoute) {
        return `/api/smbcenter/${version === ApiVersion.v1 && subRoute !== SmbCenterSubRoutes.products
            ? subRoute + '/' + version
            : version + '/' + subRoute}/`;
    }
    /**
     * Get base url for smbCenter/samba-company services calls for specific api version
     * @param version - v1, v2, or v3
     * @returns string - base url for smbCenter/samba-company services call
     */
    static getSambaCompanyBaseUrl(version) {
        return `/api/smbcenter/samba-company/${version}/`;
    }
    /**
     * Get base url for smbCenter company registration services calls for specific api version
     * @param version - v1, v2, or v3
     * @returns string - base url for smbCenter/samba-company services call
     */
    static getCompanyRegistrationBaseUrl(version) {
        return `/api/smbcenter/${version}/registration/`;
    }
}

class SmbCenterSecurityService {
    /**
     * constructor for TransactionService class
     * @param httpClient - object of HttpCLient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Make request for token to open document
     * @param ownerId - id of the owner
     * @param path - url of the document
     * @returns link that can be opened
     */
    getSsoToken(ownerId, requestBody) {
        const url = UrlBase.getSmbCenterBaseUrl(ApiVersion.v2, SmbCenterSubRoutes.security) + 'contact/' + ownerId + '/sso';
        return this.httpClient.post(url, requestBody);
    }
}
SmbCenterSecurityService.ɵfac = function SmbCenterSecurityService_Factory(t) { return new (t || SmbCenterSecurityService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
SmbCenterSecurityService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SmbCenterSecurityService_Factory() { return new SmbCenterSecurityService(i0.ɵɵinject(i1.HttpClient)); }, token: SmbCenterSecurityService, providedIn: "root" });
SmbCenterSecurityService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SmbCenterSecurityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class SmbCenterAccountingService {
    /**
     * constructor for SmbCenterAccountingService class
     * @param httpClient - object of HttpCLient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get accounts by specific tags
     * @param ownerId - id of the owner
     * @param tagList - array of tag strings
     * @returns accounts list
     */
    getAccountsByTags(ownerId, tagList) {
        let url = UrlBase.getSmbCenterBaseUrl(ApiVersion.v2, SmbCenterSubRoutes.accounting) +
            `api/smbcentercontact/${ownerId}/account/accounts-by-tags`;
        tagList.forEach((tag, index) => {
            const urlAppender = index === 0 ? '?' : '&';
            return (url += urlAppender + 'accountTags=' + tag);
        });
        return this.httpClient.get(url);
    }
}
SmbCenterAccountingService.ɵfac = function SmbCenterAccountingService_Factory(t) { return new (t || SmbCenterAccountingService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
SmbCenterAccountingService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SmbCenterAccountingService_Factory() { return new SmbCenterAccountingService(i0.ɵɵinject(i1.HttpClient)); }, token: SmbCenterAccountingService, providedIn: "root" });
SmbCenterAccountingService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SmbCenterAccountingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class SmbCenterBankingService {
    /**
     * constructor for SmbCenterBankingService class
     * @param httpClient - object of HttpCLient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get transactions for specific period
     * @param ownerId - id of the owner
     * @param periodEndDate - current period end date
     * @param filterSearchAndSort - object of filter and search settings
     * @param pagingDataRequest - object containing required pagination info
     * @returns Observable\<GridResultV1Dto\<TransactionDetailUKV2GridQueryDto\>\> - object containing needed grid info and list of transactions
     */
    getTransactionsDetail(ownerId, periodEndDate, filterSearchAndSort, pagingDataRequest) {
        let url = UrlBase.getSmbCenterBaseUrl(ApiVersion.v2, SmbCenterSubRoutes.banking) +
            `contact/${ownerId}/transaction-detail/by-period?periodEndDate=${periodEndDate.toString()}`;
        if ((pagingDataRequest === null || pagingDataRequest === void 0 ? void 0 : pagingDataRequest.itemsPerPage) && (pagingDataRequest === null || pagingDataRequest === void 0 ? void 0 : pagingDataRequest.pageIndex)) {
            url += '&itemsPerPage=' + pagingDataRequest.itemsPerPage.toString();
            url += '&pageIndex=' + pagingDataRequest.pageIndex.toString();
        }
        if (filterSearchAndSort === null || filterSearchAndSort === void 0 ? void 0 : filterSearchAndSort.search) {
            url += '&search=' + filterSearchAndSort.search + '&searchBy=entryDate';
        }
        if (filterSearchAndSort === null || filterSearchAndSort === void 0 ? void 0 : filterSearchAndSort.orderBy) {
            url += '&orderBy=' + filterSearchAndSort.orderBy;
        }
        return this.httpClient.get(url);
    }
    /**
     * Persists transaction details update
     * @param ownerId - Id of the owner
     * @param transactionDetails - Updated transactions details to save
     * @returns Persisted updated transaction details
     */
    updateTransactionDetail(ownerId, transactionDetails) {
        const url = UrlBase.getSmbCenterBaseUrl(ApiVersion.v2, SmbCenterSubRoutes.banking) +
            `contact/${ownerId}/transaction-detail/${transactionDetails.id}`;
        return this.httpClient
            .put(url, transactionDetails)
            .pipe(map((response) => response));
    }
    /**
     * Get transactions summary for specific period
     * @param ownerId - id of the owner
     * @param periodEndDate - current period end date
     * @returns List of transactions summary items
     */
    getTransactionsSummary(ownerId, periodEndDate) {
        const url = UrlBase.getSmbCenterBaseUrl(ApiVersion.v2, SmbCenterSubRoutes.banking) +
            `contact/${ownerId}/transactions-summary?periodEndDate=${periodEndDate.toString()}`;
        return this.httpClient.get(url);
    }
}
SmbCenterBankingService.ɵfac = function SmbCenterBankingService_Factory(t) { return new (t || SmbCenterBankingService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
SmbCenterBankingService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SmbCenterBankingService_Factory() { return new SmbCenterBankingService(i0.ɵɵinject(i1.HttpClient)); }, token: SmbCenterBankingService, providedIn: "root" });
SmbCenterBankingService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SmbCenterBankingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class SmbCenterSambaCompanyService {
    /**
     * constructor for SmbCenterSambaCompanyService class
     * @param httpClient - object of HttpCLient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Given an Onvio clientId and contactId, returns all data needed to login the Onbalance company.
     * @param companyId - The onvio company id.
     * @param clientId - Client id of the onvio client.
     * @param contactId - Contact id of the onvio client.
     * @returns The `SambaCompanyCredentialsV1Dto`.
     */
    getAccountantUserCredentialsV2(companyId, clientId, contactId) {
        const url = UrlBase.getSambaCompanyBaseUrl(ApiVersion.v2) +
            `company/${companyId}/client/${clientId}/contact/${contactId}/accountant-user/credentials`;
        return this.httpClient.get(url);
    }
    /**
     * Create alert for the OnBalance company associated with the given Onvio firm, client and contact.
     * @param parentCompany - Company id of the onvio firm.
     * @param clientId - Client id of the onvio client.
     * @param contactId - Contact id of the onvio client.
     * @param alertDto - Alert dto containing various periods for alert.
     * @returns The `CreateAlertsResponse`.
     */
    createAlerts(parentCompany, clientId, contactId, alertDto) {
        const url = UrlBase.getSambaCompanyBaseUrl(ApiVersion.v2) +
            `parentCompany/${parentCompany}/client/${clientId}/contact/${contactId}/create-alerts`;
        return this.httpClient.post(url, alertDto).pipe(map((response) => response));
    }
}
SmbCenterSambaCompanyService.ɵfac = function SmbCenterSambaCompanyService_Factory(t) { return new (t || SmbCenterSambaCompanyService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
SmbCenterSambaCompanyService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SmbCenterSambaCompanyService_Factory() { return new SmbCenterSambaCompanyService(i0.ɵɵinject(i1.HttpClient)); }, token: SmbCenterSambaCompanyService, providedIn: "root" });
SmbCenterSambaCompanyService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SmbCenterSambaCompanyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class SmbCenterCompanyRegistartionService {
    /**
     * constructor for SmbCenterCompanyRegistartionService class
     * @param httpClient - object of HttpCLient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get the company mapping recordfor the specified firm company's client.
     * @param parentCompany - The parent company id.
     * @param clientId - The id to request mapping for.
     * @returns The `CompanyMappingV1Dto`.
     */
    getCompanyMappingRecordForClientV1(parentCompany, clientId) {
        const url = UrlBase.getCompanyRegistrationBaseUrl(ApiVersion.v1) + `parentCompany/${parentCompany}/client/${clientId}`;
        return this.httpClient.get(url);
    }
    /**
     * Gets the all OnBalance linked data of the Onvio Company.
     * @param parentCompany - The parent company id.
     * @returns The `CompanyLinkedDataV1Dto`.
     */
    getOnBalanceLinkedDataForCompanyV1(parentCompany) {
        const url = UrlBase.getCompanyRegistrationBaseUrl(ApiVersion.v1) + `parentCompany/${parentCompany}/calculated-linked-values`;
        return this.httpClient.get(url);
    }
    /**
     *
     * @param parentCompany - The parent company id.
     * @param clientId - The client id to get mapping for.
     * @param contactId - The contact id to get mapping for.
     * @returns The `CompanyMappingV2Dto`.
     */
    getCompanyMappingRecordForClientAndContactV3(parentCompany, clientId, contactId) {
        const url = UrlBase.getCompanyRegistrationBaseUrl(ApiVersion.v3) +
            `parentCompany/${parentCompany}/client/${clientId}/contact/${contactId}`;
        return this.httpClient.get(url);
    }
    /**
     * Creates a company mapping record.
     * @param inputDto - Info required to create the mapping record.
     * @returns The `CompanyMappingV2Dto`.
     */
    createCompanyMappingV2(inputDto) {
        return this.httpClient.post(UrlBase.getCompanyRegistrationBaseUrl(ApiVersion.v2), inputDto);
    }
    /**
     * Creates a company mapping record.
     * @param inputDto - Info required to create the mapping record.
     * @returns The `CompanyMappingV2Dto`.
     */
    createCompanyMappingV3(inputDto) {
        return this.httpClient.post(UrlBase.getCompanyRegistrationBaseUrl(ApiVersion.v3), inputDto);
    }
    /**
     * Delete the company mappinglink record.
     * @param parentCompany - The parent company id.
     * @param clientId - The client id to request mapping for.
     * @returns 204 HTTP status code.
     */
    deleteCompanyMappingRecordForClientV1(parentCompany, clientId) {
        const url = UrlBase.getCompanyRegistrationBaseUrl(ApiVersion.v1) + `parentCompany/${parentCompany}/client/${clientId}`;
        return this.httpClient.delete(url);
    }
    /**
     * Delete the company mappinglink record.
     * @param parentCompany - The parent company id.
     * @param clientId - The client id to delete mapping for.
     * @param contactId - The contact id to delete mapping for.
     * @returns 204 HTTP status code.
     */
    deleteCompanyMappingRecordForClientAndContactV3(parentCompany, clientId, contactId) {
        const url = UrlBase.getCompanyRegistrationBaseUrl(ApiVersion.v3) +
            `parentCompany/${parentCompany}/client/${clientId}/contact/${contactId}`;
        return this.httpClient.delete(url);
    }
    /**
     * Check the on balance company mapping
     * @param parentCompany - The parent company id.
     * @param clientId - The client id to request mapping for.
     * @returns Boolean option if client has balance
     */
    hasOnBalanceMapping(parentCompany, clientId) {
        const url = UrlBase.getCompanyRegistrationBaseUrl(ApiVersion.v2) +
            `parentCompany/${parentCompany}/identifier/${clientId}/has-link`;
        return this.httpClient.get(url).pipe(map((response) => response.value));
    }
}
SmbCenterCompanyRegistartionService.ɵfac = function SmbCenterCompanyRegistartionService_Factory(t) { return new (t || SmbCenterCompanyRegistartionService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
SmbCenterCompanyRegistartionService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SmbCenterCompanyRegistartionService_Factory() { return new SmbCenterCompanyRegistartionService(i0.ɵɵinject(i1.HttpClient)); }, token: SmbCenterCompanyRegistartionService, providedIn: "root" });
SmbCenterCompanyRegistartionService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SmbCenterCompanyRegistartionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class OnBalanceServicesModule {
}
OnBalanceServicesModule.ɵfac = function OnBalanceServicesModule_Factory(t) { return new (t || OnBalanceServicesModule)(); };
OnBalanceServicesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OnBalanceServicesModule });
OnBalanceServicesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        SmbCenterAccountingService,
        SmbCenterBankingService,
        SmbCenterSecurityService,
        SmbCenterSambaCompanyService,
        SmbCenterCompanyRegistartionService,
    ], imports: [[HttpClientModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OnBalanceServicesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [HttpClientModule],
                exports: [],
                providers: [
                    SmbCenterAccountingService,
                    SmbCenterBankingService,
                    SmbCenterSecurityService,
                    SmbCenterSambaCompanyService,
                    SmbCenterCompanyRegistartionService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OnBalanceServicesModule, { imports: function () { return [HttpClientModule]; } }); })();

class DtoBase {
}

class Account extends DtoBase {
}

class TransactionDetailUKV2GridQueryDto extends DtoBase {
}

class FilterSearchAndSortRequest {
}

class PagingDataRequest {
}

class GridResultV1Dto extends DtoBase {
}

class TransactionsSummaryItem {
}

class SmbCenterProductsService {
    /**
     * constructor for SmbCenterProductsService class
     * @param httpClient - object of HttpCLient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get products
     * @returns products list
     */
    getProducts() {
        const url = UrlBase.getSmbCenterBaseUrl(ApiVersion.v1, SmbCenterSubRoutes.products);
        return this.httpClient.get(url);
    }
}
SmbCenterProductsService.ɵfac = function SmbCenterProductsService_Factory(t) { return new (t || SmbCenterProductsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
SmbCenterProductsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SmbCenterProductsService_Factory() { return new SmbCenterProductsService(i0.ɵɵinject(i1.HttpClient)); }, token: SmbCenterProductsService, providedIn: "root" });
SmbCenterProductsService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SmbCenterProductsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class Product {
}

var SsoTokenRequestBodyEnum;
(function (SsoTokenRequestBodyEnum) {
    SsoTokenRequestBodyEnum["Vertical"] = "DocumentServices";
})(SsoTokenRequestBodyEnum || (SsoTokenRequestBodyEnum = {}));

class SsoTokenRequestBody {
}

class CompanyLinkedDataV1Dto {
}

/**
 * The DTO that represents the company mapping record.
 */
class CompanyMappingV1Dto {
}
/**
 * The DTO that represents the company mapping record.
 * The difference between V1 DTO is that it contains the 2 additional fields, product code and array of sub mappings.
 */
class CompanyMappingV2Dto extends CompanyMappingV1Dto {
}

/**
 * The DTO to create the company mapping record.
 */
class CompanyRegistrationV1Dto {
}

/**
 * The DTO with additional information about company mapping.
 * Used in the `CompanyMappingV2Dto`.
 */
class SubMappingV1Dto {
}

class AlertsV1Dto {
}

class CreateAlertsResponse {
}

class PeriodDatesV1Dto {
}

class SambaCompanyCredentialsV1Dto {
}

/*
 * Public API Surface of onbalance-services
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Account, AlertsV1Dto, CompanyLinkedDataV1Dto, CompanyMappingV1Dto, CompanyMappingV2Dto, CompanyRegistrationV1Dto, CreateAlertsResponse, FilterSearchAndSortRequest, GridResultV1Dto, OnBalanceServicesModule, PagingDataRequest, PeriodDatesV1Dto, Product, SambaCompanyCredentialsV1Dto, SmbCenterAccountingService, SmbCenterBankingService, SmbCenterCompanyRegistartionService, SmbCenterProductsService, SmbCenterSambaCompanyService, SmbCenterSecurityService, SsoTokenRequestBody, SsoTokenRequestBodyEnum, SubMappingV1Dto, TransactionDetailUKV2GridQueryDto, TransactionsSummaryItem, DtoBase as ɵa };

